// import { ifAuthenticated } from "@/Modules/User/Routes/guards"

export default [
  {
    path: "/document-templates",
    name: "DocumentTemplates",
    meta: { title: "Document Templates" },
    component: () => import(/* webpackChunkName: "DocumentTemplates" */ "@/Modules/DocumentTemplate/Views/List.vue")
    // beforeEnter: ifAuthenticated
  }
]
